<template>
  <div>
    <el-dialog
      title="创建喇叭任务"
      center
      width="700px"
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
    <div>待开发</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: true,
      toBeSentText: "", // 要发送的文本
    };
  },

  methods: {
    /**
     * 提交表单
     */
    async submit() {
    },

    /**
     * 关闭自己
     */
    close() {
      this.visible = false;
    },

    /**
     * 自己被关闭了
     */
    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>
